/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../../api/index';
import * as core from '../../core';
import * as serializers from '../index';
import { CredentialProof } from './CredentialProof';

export const CredentialProofs: core.serialization.Schema<serializers.CredentialProofs.Raw, Truvity.CredentialProofs> =
    core.serialization.list(CredentialProof);

export declare namespace CredentialProofs {
    export type Raw = CredentialProof.Raw[];
}
